<template lang="html">
  <div class="info-list-container">
    <div v-for="( item , key , index ) of data"
    v-bind:key="index" :id="item.id" class="card" v-on:click="goToAssetClass($event)">
    <div class="sectionOne">
      <div ref="circle" :class="['circle', item.id]">
      </div>
      <p style="text-decoration: underline"> {{ item.name }} </p> 
        <p class="alignRight"><i class="el-icon-arrow-right"></i></p>
    </div>
    <div class="sectionTwo">
      <div class="divisor">
        <p ref="percentage" :class="['percentage', item.id]"> {{ formatPercentage(item.percentage) }}</p>
      </div>
      <div class="divisor">
        <p class="alignRight">{{ formatAmount(item.amount) }} </p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    data: Array
  },
  methods: {
    formatPercentage (percentage) {
      percentage = percentage*100
      return `${percentage.toFixed(2)}%`
    },
    formatAmount (amount) {
      amount = parseFloat(amount)
      return `$${amount.toLocaleString()}`
    },
    goToAssetClass(event) {
      event.preventDefault();
      const assetClass = event.currentTarget.id
      this.$router.push(
        `/analisis-portafolio/${this.$route.params.id}/mercado/${assetClass}`
      );
    }
  },
};
</script>
<style lang="css">
.info-list-container {
  width: 220px;
  height: 400px;
  float: right;
  margin-bottom: 20px;
  line-height: 14px;
  position: relative;
  top: 20px;
}

.card {
  cursor: pointer;
  border-bottom: 1px dashed #e3ecff;
}

.circle {
  transition: background-color 0.5s;
  border-radius: 30px;
  background-color: white;
  width: 12px;
  height: 12px;
  display: inline-block;
  position: relative;
  top: 1px;
  margin-right: 12px;
}

.circle.deuda {
  background-color: #97E3D6;
}

.circle.estructurados {
  background-color: #FB8070;
}

.circle.capitales {
  background-color: #B3DE69;
}

.circle.fondosrf {
  background-color: #C2BFE0;
}

.circle.fondosrv {
  background-color: #FDB462;
}

.percentage.deuda {
  color: #97E3D6;
}

.percentage.estructurados {
  color: #FB8070;
}

.percentage.capitales {
  color: #B3DE69;
}

.percentage.fondosrf {
  color: #C2BFE0;
}

.percentage.fondosrv {
  color: #FDB462;
}

.sectionOne p {
  display: inline-block;
  max-width: 110px;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
}

.sectionTwo {
  padding-left: 30px;
}

.sectionTwo p {
  font-size: 14px;
  margin-top: 0;
}

.divisor {
  display: inline-block;
  width: 47%;
}

.alignRight {
  text-align: right;
}

.percentage {
  font-weight: bold;
  transition: color 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoListDonnut.vue